
export const activeSearchEschema = [

{
    id:1,
    name:'name',
    type:'text',
    labelTitle:'Nombre'
},
{
    id:2,
    name:'formationPlace',
    select:'true',
    labelTitle:'Lugar'
}
]